<page-header
    [icon]="['SIDEMENUES', 'ADMIN', 'SOURCE_CODE_EXCLUDES'] | monIcons"
    [header]="'Source Code Excludes' | translate">
    <page-header-content>
        <div class="row">
            <div class="col-48 col-md-48 text-right">
                <button class="btn btn-border-radius btn-secondary"
                        (click)="openDialog()"
                        monEventTrigger="actionTrigger"
                        [monEventParams]="{action: 'source-code-exclude-new'}"
                        type="button"
                        translate>
                    Add source code exclude
                </button>
            </div>
        </div>
    </page-header-content>
</page-header>

<mon-tabs
    [options]="tabs"
    [(status)]="activeTab"
    (onStatus)="onStatus($event)">
</mon-tabs>

<div class="card panel-monsido-card">
    <div class="card-body">
        <table-container
            [collection]="sourceCodeExcludes"
            (onPageChange)="onPageChange($event)"
            (onPerPageChange)="onPageSizeChange($event)"
            class="table-vertial-align"
            [progress]="promise">
            <table class="table table-hover table-fixed">
                <thead>
                    <tr>
                        <th class="col-sm-8 col-md-6" translate>Owner</th>
                        <th class="col-sm-32 col-md-34" translate>Description</th>
                        <th class="col-sm-8 col-md-6">&nbsp;</th>
                    </tr>
                </thead>
                <tbody>
                    <tr *ngFor="let sourceCodeExclude of sourceCodeExcludes; trackBy: trackBySourceCodeExclude">
                        <td class="text">
                            {{sourceCodeExclude.owner_type}}
                        </td>
                        <td class="text">
                            <span *ngIf="isAccessibility(activeTab)">
                                {{sourceCodeExclude.short_description}}
                            </span>
                            <span *ngIf="!isAccessibility(activeTab)">
                                {{sourceCodeExclude.title}}
                            </span>
                        </td>
                        <td class="text-right vertical-align-middle">
                            <mon-action-menu [monActionMenuItems]="sourceCodeExclude.dropdown">
                                <span translate>Action</span>
                            </mon-action-menu>
                        </td>
                    </tr>
                </tbody>
            </table>
        </table-container>
    </div>
</div>
